
<script>
import config from "../../config";
import pagination from "laravel-vue-pagination";
import { vendorService, settingService} from "../../services";
import { replaceByDefault,get_user } from "../../Helper/helper";

export default {
  components: { pagination, vendorService, settingService},
  data() {
    const { is_confirm,orderBy,sortBy} = this.$route.query;
    return {
      media:[],
      replaceByDefault:replaceByDefault,
      vendorData: [],
      config: config,
      sortBy: sortBy || "created_date",
      vendor_currency: "",
      sortDesc: orderBy && orderBy != '' ? true : orderBy,
      vendors: [],
      vendorCount: '',
      paginations: {},
      limit: 2,
      is_confirm: is_confirm == undefined ? 1 :is_confirm ,
      setting: [],
      vendor_id: "",
      loading: true,
      fields: [
        {
          key: "icon_image",
          label: "#",
          sortable: false,
          thClass:"dis-event"
        },
        {
          key: "name",
          label: this.trans.get("__JSON__.Vendor Name"),
          sortable: false,
        },
        {
          key: "unique",
          label: this.trans.trans("__JSON__.Vendor Id"),
          sortable: false,
          thClass:"dis-event"
        },
        {
          key: "address",
          label: this.trans.get("__JSON__.Location"),
          sortable: false,
          thClass:"dis-event"
        },
        {
          key: "order_count",
          label: this.trans.get("__JSON__.Orders"),
          sortable: false,
        },
        {
          key: "is_confirm",
          label: this.trans.get("__JSON__.Status"),
          sortable: false,
          thClass:"dis-event"
        },
        {
          key: "action",
          label: this.trans.get("__JSON__.Action"),
          sortable: false,
          thClass:"dis-event"
        },
      ],
    };
  },

  mounted() {
    this.getAppSetting();
    this.getVendor();
    this.vendor_id = get_user().vendor_id || 40818;
  },
  methods: {
    onRowClicked(item) {
      this.$router.push({name: 'vendor-detail',params: { restaurant_id: this.base64(item.restaurant_id)}})
    },
    getAppSetting() {
      this.fields[1].label = this.$auth.getRestaurantName();
      this.fields[2].label = this.$auth.getRestaurantName()+' Id';
    },
    getSetting() {
      settingService.getSetting().then((response) => {
        this.vendor_currency = response.data.result.currency;
      });
    },
    getVendor() {
      this.loading = true;
      if (this.sortBy == "name") {
        this.sortDesc = false;
      } else {
        this.sortDesc = true;
      };
      var filters = {
        is_confirm: this.is_confirm,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
      }
      vendorService
        .getVendorList(filters)
        .then((response) => {
          this.loading = false;
          this.vendors = response.data.result;
          this.vendorCount = response.data.result.length;
        });
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getVendor();
    }
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left">
            <div class="avatar-xs mr-3">
              <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                <i class="bx bx-store"></i>
              </span>
            </div>
            <h4
              class="mb-0 font-size-18"
            >{{ trans.trans('__JSON__.Vendors',{ vendor: $auth.setting.restaurant_name }) }}({{vendorCount}})</h4>
          </div>
          
        </div>
      </div>
    </div>
    <!-- end row -->
    <div class="row">
      <div class="col-12 list-table-main">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 table-main-list vendor-table table-responsive">
                <b-table
                  :items="vendors"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :busy="loading"
                  show-empty
                  @row-clicked="onRowClicked"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{trans.get('__JSON__.Loading...')}}</strong>
                    </div>
                  </template>

                  <template v-slot:cell(icon_image)="data">
                    <div v-if="data.item.icon_image">
                      <img
                        alt
                        class="vendor-img avatar-xs"
                        v-lazy="(config.restauranticon+data.item.icon_image) || config.no_image"
                      />
                    </div>
                    <div v-else>
                      <img class="vendor-img avatar-xs" :src="config.basepath+'no-img.png'" alt />
                    </div>
                  </template>

                  <template v-slot:cell(name)="data">
                    <h5 class="font-size-14">
                      <div v-if="data.item.name && data.item.name.length > 25">{{data.item.name.substr(0, 25)+ '...'}}</div>
                      <div v-else>{{data.item.name}}</div>
                    </h5>
                  </template>

                  <template v-slot:cell(unique)="data">
                    <h5 class="font-size-14"><div>{{data.item.unique}}</div></h5>
                  </template>

                  <template v-slot:cell(address)="data">
                    <div v-if="data.item.address">
                      <div
                        v-if="data.item.address.length > 60"
                      >{{data.item.address.substr(0, 60)+ '...'}}</div>
                      <div v-else>{{data.item.address}}</div>
                    </div>
                  </template>

                  <template v-slot:cell(is_confirm)="data">
                    <div
                      v-if="data.item.is_confirm == '0'"
                      class="badge badge-pill badge-soft-danger font-size-12"
                    >{{ trans.get('__JSON__.Inactive') }}</div>
                    <div
                      v-if="data.item.is_confirm == '1'"
                      class="badge badge-pill badge-soft-success font-size-12"
                    >{{ trans.get('__JSON__.Active') }}</div>
                    <div
                      v-if="data.item.is_confirm == '2'"
                      class="badge badge-pill badge-soft-warning font-size-12"
                    >{{ trans.get('__JSON__.Waiting For Approval') }}</div>
                  </template>

                  <template v-slot:cell(action)="data">
                    <div class="vendor-btn">
                      <router-link
                        :to="{name: 'vendor-detail',params: { restaurant_id: base64(data.item.restaurant_id)}}"
                        class="btn btn-primary btn-sm btn-rounded"
                      >{{ trans.get('__JSON__.View') }}</router-link>
                      <!-- <router-link
                        :to="{name: 'vendor-catalog',params: { restaurant_id: base64(data.item.restaurant_id)}}"
                        class="btn btn-success btn-sm btn-rounded"
                      >{{ trans.get('__JSON__.Catalog') }}</router-link> -->
                    </div>
                  </template>

                  <template #empty>
                    <p class="text-center">{{ trans.get('__JSON__.No Vendor Found') }}</p>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
